import script from "./AgencyOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgencyOverview.vue?vue&type=script&setup=true&lang=ts"

import "./AgencyOverview.vue?vue&type=style&index=0&id=0479d1ca&lang=scss"

const __exports__ = script;

export default __exports__